<template>
  <v-app id="inspire">
    <v-snackbar
      v-model="isError"
      color="error"
      :timeout="5000" >
      Beim Updaten der Rechte ist ein Fehler aufgetreten
    </v-snackbar>
    <v-container fluid id="mainFrame">
      <InfoDialog ref="infoDialog" />
     <v-row>
        <v-col class="text-left" style="max-width: fit-content;">
          <IconTooltipButtonBottom
              @click="$router.push('/management')"
              icon="mdi-arrow-left"
              tooltip="Zurück"
              large
          />
        </v-col>
        <v-col style="align-self: center">
          <h3>Rollenverwaltung</h3>
        </v-col>
      <v-col class="text-right">
        <v-btn color="primary" @click="addRole()" elevation="0">
          <v-icon color="#F5F5F5" medium>add</v-icon > Neue Rolle
        </v-btn>
      </v-col>
      </v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Aktionen</th>
              <th class="text-left">Rollen-ID</th>
              <th class="text-left">Bezeichnung</th>
              <th style="width:25px" v-for="permission in permissions" :key="permission"> 
                <v-tooltip max-width="250px" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs">
                      {{decodePermissionName(permission)}}
                    </div>
                  </template>
                  <span> {{getPermissionDescription(permission)}} </span>
                </v-tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="role in roles" :key="role.id">
              <td>
                <v-icon color="tr_red" @click="deleteRole(role.id, role.roleTitle)">mdi-delete</v-icon>
              </td>
              <td>{{ role.id }}</td>
              <td>{{ role.roleTitle }}</td>
              <td style="width:25px" v-for="permission in permissions" :key="permission">
                <v-checkbox
                  v-model="role.permissions[permission]"
                  color="secondary"
                  @change="managePermissions(role)"
                ></v-checkbox>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
    <AddRoleDialog ref="addRoleDialog" />
    <ConfirmDialog ref="confirmDialog" />
  </v-app>
</template>

<script>
import roleService from "@/pages/UserManagement/roleService"
import permissionService from "@/components/permissionService";
import InfoDialog from "@/components/common/InfoDialog";
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom";
import AddRoleDialog from './Dialogs/AddRoleDialog.vue';
import ConfirmDialog from '../../components/common/ConfirmDialog.vue';
import {decodePermissionName, getPermissionDescription} from '@/components/util.js'
export default {
  name: "adminPanel",
  components:{
    InfoDialog,
    AddRoleDialog,
    ConfirmDialog,
    IconTooltipButtonBottom
  },
  data() {
    return {
      roles: [],
      permissions:[],
      isError: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    decodePermissionName: decodePermissionName,
    getPermissionDescription: getPermissionDescription,
    deleteRole(roleId, roleName){
    this.$refs.confirmDialog
    .open(
      "Rolle löschen",
      "Wollen Sie die Rolle "+roleName+" wirklich löschen?"
    )
    .then(() => {
        roleService.deleteRole(roleId).then(res => this.init())
      .catch(e => {
        this.$refs.infoDialog.open(
          "Fehler beim Löschen",
          "Diese Rolle ist mit einem Nutzer verknüpft und kann daher nicht gelöscht werden. Ordnen Sie Nutzer mit dieser Rolle anderen Rollen zu um diese Rolle zu löschen."
        );
      })
    });
     
    },
    managePermissions(role){
        permissionService.updatePermission(role).then((res) => this.isError = !res);
    },
    addRole(){
      this.$refs.addRoleDialog
      .open()
      .then(() => {
        this.init();
      });
    },
    init() {
      roleService.retrieveRoles().then((res) => (this.roles = res.data));
      permissionService.retrievePossiblePermissions().then(res => this.permissions = res.data);
    },
  },
};
</script>
<style scoped>
#mainFrame {
  overflow: visible;
}
th, td{
  vertical-align: middle;
}
.h3, h3{
  margin: 0;
}
</style>